import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingCart, Menu, X, MessageCircle } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useSettings } from "@/context/SettingsContext";
import { openWhatsApp } from "@/lib/whatsapp";

const NAV = [
  { label: "Shop", to: "/#products" },
  { label: "Freshness", to: "/#freshness" },
  { label: "Process", to: "/#process" },
  { label: "Story", to: "/about" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export default function Header() {
  const { count, setOpen } = useCart();
  const { settings } = useSettings();
  const [menu, setMenu] = useState(false);
  const navigate = useNavigate();
  const brand = settings?.brand || {};

  const go = (to) => {
    setMenu(false);
    if (to.startsWith("/#")) {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById(to.slice(2));
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 120);
    } else {
      navigate(to);
    }
  };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-cream/85 border-b border-forest/10 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" data-testid="nav-logo" className="flex items-center shrink-0">
          <img src="/brand/logo.png" alt="Areeba Multigrain Aata — Har Roti Mein Tazgi" className="h-10 sm:h-12 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <button
              key={n.label}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              onClick={() => go(n.to)}
              className="text-sm font-medium text-charcoal/80 hover:text-forest transition-colors"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <button
            data-testid="nav-whatsapp-button"
            onClick={() => openWhatsApp()}
            className="hidden sm:inline-flex items-center gap-2 text-sm font-semibold text-white bg-whatsapp px-3 py-2 rounded-full hover:opacity-90 transition-opacity"
          >
            <MessageCircle size={16} /> WhatsApp
          </button>
          <button
            data-testid="nav-cart-button"
            onClick={() => setOpen(true)}
            className="relative p-2 rounded-full hover:bg-forest/10 transition-colors"
            aria-label="Cart"
          >
            <ShoppingCart size={22} className="text-forest-dark" />
            {count > 0 && (
              <span
                data-testid="nav-cart-count"
                className="absolute -top-0.5 -right-0.5 bg-wheat text-forest-dark text-[11px] font-bold rounded-full h-5 min-w-5 px-1 flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </button>
          <button
            className="lg:hidden p-2 rounded-full hover:bg-forest/10"
            onClick={() => setMenu((m) => !m)}
            data-testid="nav-menu-toggle"
            aria-label="Menu"
          >
            {menu ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {menu && (
        <div className="lg:hidden border-t border-forest/10 bg-cream px-4 py-3 space-y-1">
          {NAV.map((n) => (
            <button
              key={n.label}
              onClick={() => go(n.to)}
              className="block w-full text-left py-2.5 px-2 rounded-lg text-charcoal hover:bg-forest/5 font-medium"
              data-testid={`mobile-nav-${n.label.toLowerCase()}`}
            >
              {n.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
